<template>
  <v-dialog v-model="dialog" persistent max-width="900">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <div
            v-bind="tooltip.attrs"
            v-on="possuiPropostaEmProcessamento && tooltip.on"
          >
            <v-btn
              v-on="on"
              color="primary"
              class="mr-3"
              :disabled="possuiPropostaEmProcessamento"
            >
              <slot name="title"></slot>
            </v-btn>
          </div>
        </template>
        Não é possível gerar nova proposta, devido à existência de uma
        em processamento.
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="fechar" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h3>Para gerar uma nova proposta, escolha combo abaixo</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ComboboxCombos :filter="novaProposta"></ComboboxCombos>
          </v-col>
        </v-row>
        <template v-if="!novaProposta.combo">
          <v-row>
            <v-col>
              <strong> Combo Essencial:</strong> Até 3 eixos, sendo no mínimo 2
              do ambiente de negócios;
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <strong> Combo Premium:</strong> Até 4 eixos, sendo no mínimo 2 do
              ambiente de negócios;
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <strong>Combo Ultimate:</strong> Até 5 eixos, sendo no mínimo 2 do
              ambiente de negócios;
            </v-col>
          </v-row>
          <v-row>
            <v-col style="display: flex; align-items: center; max-width: 90%">
              <div style="margin-right: 10px">
                <strong>Combo PLUS ou Flex:</strong> Até 02 eixos, incluindo os
                que ele já está, incluindo também a possibilidade de selecionar
                uma reaplicação de soluções já existentes no município.
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="tooltip">
                  <div v-bind="tooltip.attrs" v-on="tooltip.on">
                    <v-icon color="primary">mdi-information</v-icon>
                  </div>
                </template>
                O combo Plus ou Flex será liberado ao marcar nos dados
                cadastrais que o município faz parte do pacote do governo do
                estado.
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col
              ><ComboboxGroupSolution
                :filter="{
                  grupoSolucaoId: atualGrupoSolucao,
                }"
                @changeGroupSolution="changeGroupSolution"
              ></ComboboxGroupSolution>
            </v-col>
            <v-col v-if="atualGrupoSolucao">
              <ComboboxSolution
                :filter="{
                  solutions: atualSolutions,
                  solucaoId: selectedSolutions,
                }"
                multiple
                @changeSolution="changeSolution"
                returnObject
                :solutionIds="[]"
              ></ComboboxSolution>
            </v-col>
          </v-row>
          <v-row v-if="selectedSolutions && selectedSolutions.length > 0">
            <v-col v-if="valorCusto">
              O valor de custo das soluções é R${{ this.valorCusto }}
            </v-col>
            <v-col style="display: flex">
              <v-btn
                @click="calcularCustos"
                color="primary"
                class="mr-3"
                style="margin-left: auto"
              >
                Calcular custos
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                :headers="headers"
                :items="selectedSolutions"
                class="elevation-1 w-100 proposta"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.acoes="{ item }">
                  <v-btn
                    outlined
                    color="error"
                    class="mr-3"
                    @click="deleteProposta(item)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>

                <template slot="no-data">
                  <span> Nenhum eixo adicionado </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="fechar">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">
          <slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { atoresApi } from "@/apis";
import { mapActions, mapGetters } from "vuex";
import ComboboxGroupSolution from "@/modules/group-solution/components/Combobox.vue";
import ComboboxSolution from "@/modules/solution/components/Combobox.vue";
import { solutionAPI } from "@/modules/solution/components/SolutionAPI";
import { propostaApi } from "@/apis/proposta";
import { statusPropostasEnum } from "./statusPropostasEnum";
import moment from "moment";
import ComboboxCombos from "./ComboboxCombos";
export default {
  name: "ModalNovaProposta",
  components: {
    ComboboxGroupSolution,
    ComboboxSolution,
    ComboboxCombos,
  },
  props: {
    payload: { type: Object, required: true },
    possuiPropostaEmProcessamento: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(["isFullAdmin", "propostaSolucaoIdObrigatorio", "city"]),
  },
  data() {
    return {
      dialog: false,
      atualGrupoSolucao: null,
      atualSolutions: [],
      selectedSolutions: [],
      novaProposta: { groupSolution: [] },
      valorCusto: null,
      headers: [
        { text: "Grupo", value: "grupoSolucao.nome", align: "center" },
        { text: "Solução", value: "nome", align: "center" },
        { text: "Ações", value: "acoes", align: "center" },
      ],
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["setLoading"]),
    calcularCustos() {
      this.valorCusto = this.selectedSolutions.reduce(
        (acumulador, valorAtual) => {
          if (valorAtual.custo) {
            return valorAtual.custo + acumulador;
          } else return acumulador;
        },
        0
      );
    },
    onConfirm() {
      this.setLoading(true);
      var proposta = {
        municipioId: this.$route.params.id,
        status: statusPropostasEnum.emProcessamento,
        municipioPropostaGrupoSolucao: this.selectedSolutions.map((item) => ({
          idSolucao: item.solucaoId,
          idGrupoSolucao: item.grupoSolucao.grupoSolucaoId,
        })),
      };

      propostaApi
        .gerarProposta(proposta)
        .then((data) => {
          this.$notification.success("Proposta gerada com sucesso!");
          this.fazerDownloadRelatorio(
            data.data,
            `Termo de Adesão - ${this.city}`
          );

          this.$emit("onLoad");
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    deleteProposta(item) {
      this.selectedSolutions = this.selectedSolutions.filter(
        (val) => item !== val
      );
    },
    changeSolution(solutions) {
      this.selectedSolutions = solutions;
      this.valorCusto = null;
      this.$forceUpdate();
    },
    async loadSolutionsByGroup(val) {
      try {
        this.atualSolutions = [];
        this.valorCusto = null;
        const data = await solutionAPI.getSolutions([val]);
        this.atualSolutions = data.data.filter(
          (val) =>
            !this.propostaSolucaoIdObrigatorio.some((ob) => val.solucaoId == ob)
        );
        this.$forceUpdate();
      } catch (error) {
        console.log("🚀 ~ loadSolutionsByGroup ~ error:", error);
      }
    },
    fazerDownloadRelatorio(file, nomeArquivo) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${nomeArquivo} - ${moment().format("DD.MM.YYYY.HH.mm")}.pdf`
      );

      document.body.appendChild(fileLink);
      fileLink.click();
      this.dialog = false;
      this.setLoading(false);
    },
    changeGroupSolution(grupoSolucaoId) {
      this.atualGrupoSolucao = grupoSolucaoId;
      this.loadSolutionsByGroup(this.atualGrupoSolucao);
    },
    fechar() {
      this.selectedSolutions = [];
      this.atualGrupoSolucao = null;
      this.dialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.comboEssencial {
  color: var(--corPrimaria);
  cursor: pointer;
}
.combo {
  .header {
    background: black;
    margin-left: -28px;
    width: 135%;
    text-align: center;
    margin-top: -16px;
    margin-bottom: 5px;
  }
}
</style>
